import React from "react";

/* Card brands and wallets accepted through SHOP NOW's Stripe checkout. Apple Pay / Google Pay appear automatically on supported devices. */
const BRANDS = [
  ["Amex", "#016FD0", "#fff", "AMEX"], ["Apple Pay", "#000", "#fff", " Pay"], ["Diners Club", "#fff", "#0079BE", "DC"], ["Discover", "#fff", "#F76F20", "DISCOVER"],
  ["Google Pay", "#fff", "#5F6368", "G Pay"], ["JCB", "#fff", "#0E4C96", "JCB"], ["Mastercard", "#1a1a1a", "#EB001B", "●●"], ["Visa", "#1434CB", "#fff", "VISA"],
];

export function PaymentLogos({ size = "md", className = "" }) {
  const h = size === "sm" ? "h-6 w-10 text-[8px]" : "h-8 w-12 text-[10px]";
  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`} data-testid="payment-logos" aria-label="Accepted payment methods">
      {BRANDS.map(([name, bg, fg, label]) => (
        <span key={name} title={name} className={`${h} rounded-md border border-black/10 grid place-items-center font-black tracking-tight select-none`} style={{ background: bg, color: fg }} data-testid={`pay-logo-${name.toLowerCase().replace(/\s+/g, "-")}`}>
          {name === "Mastercard" ? <span className="relative inline-block w-6 h-4"><span className="absolute left-0 top-0 h-4 w-4 rounded-full" style={{ background: "#EB001B" }} /><span className="absolute left-2 top-0 h-4 w-4 rounded-full opacity-90" style={{ background: "#F79E1B" }} /></span>
            : name === "Diners Club" ? <span className="inline-block h-4 w-6 rounded-full border-[3px]" style={{ borderColor: fg }} />
            : <span className={name === "Discover" ? "italic" : ""}>{label}</span>}
        </span>
      ))}
    </div>
  );
}

export const PAYMENT_METHODS_TEXT = "Visa · Mastercard · Amex · Discover · Diners · JCB · Apple Pay · Google Pay";
